// src/firebase.js
// REPLACE these values with your Firebase project config from Firebase Console
// Go to: Firebase Console > Project Settings > Your apps > Web app > Config

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyABgsWyYEFwVgqJv-tTj7p9aOWg2ePnj5Q",
  authDomain: "pcsgoshala.firebaseapp.com",
  projectId: "pcsgoshala",
  storageBucket: "pcsgoshala.firebasestorage.app",
  messagingSenderId: "39373544665",
  appId: "1:39373544665:web:2647e5d8510e270c4972c8",
  measurementId: "G-VM00B2ECWJ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
